import { Injectable } from '@angular/core';
import type { DDSReportInterface } from '@zaoblako/shared/modules/report/dtos/dds/dds.report.dto';
import type { DDSReportQueryInterface } from '@zaoblako/shared/modules/report/dtos/dds/dds.report.query.dto';
import type { DDSTaskFindQueryInterface } from '@zaoblako/shared/modules/report/dtos/dds/dds.task.find.query.dto';
import type { PaymentOutgoingItemInterface } from '@zaoblako/shared/modules/finance/dtos/payment-outgoing/payment-outgoing-item.dto';
import type { PaymentOutgoingQueryInterface } from '@zaoblako/shared/modules/finance/dtos/payment-outgoing/payment-outgoing-query.dto';
import type { DdsTaskFindInterface } from '@zaoblako/shared/modules/report/dtos/dds/dds.task.find.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReportService extends BaseService {
  protected baseUrl = '/report';

  public dds(params: DDSReportQueryInterface): Observable<DDSReportInterface> {
    return this.http.get<DDSReportInterface>(`${this.baseUrl}/dds`, { params: this.objectToHttpParams(params) });
  }

  public getDdsTasks(params: DDSTaskFindQueryInterface): Observable<DdsTaskFindInterface[]> {
    return this.http.get<DdsTaskFindInterface[]>(`${this.baseUrl}/dds/tasks`, { params: this.objectToHttpParams(params) });
  }

  public paymentOutgoing(queryParams: PaymentOutgoingQueryInterface): Observable<PaymentOutgoingItemInterface[]> {
    return this.http.get<PaymentOutgoingItemInterface[]>(`${this.baseUrl}/payment-outgoing`, {
      params: this.objectToHttpParams(queryParams)
    });
  }
}
